<script setup>
import GenericEvent from '@/components/events/GenericEvent.vue';
import FordButton from '@/components/FordButton.vue';
import DisclosurePopover from '@/components/DisclosurePopover.vue';
import { useToast } from 'vue-toastification';
import { ref, watch, computed } from 'vue';

const props = defineProps({
  event: Object,
  statuses: Object,
  status: String,
});

const toast = useToast();

const question = ref('');

const emit = defineEmits(['submit-question']);

const submitQuestion = () => emit('submit-question', question.value);

const loading = computed(() => props.status === props.statuses.loading);
const error = computed(() => props.status === props.statuses.error);
const success = computed(() => props.status === props.statuses.success);

watch(success, (value) => {
  if (value) {
    toast.success(
      'Your question was successfully submitted!',
      { timeout: 10000 },
    );

    question.value = '';
  }
});

</script>
<template>
  <generic-event :event="event">
    <template v-slot:hero-section>
      <div class="relative overflow-hidden w-full pt-[56.25%]">
        <iframe
            class="absolute top-0 left-0 bottom-0 right-0 w-full h-full"
            :title="`${event?.name} video`"
            :src="event?.videoId"
            width="100%"
            height="100%"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen></iframe>
      </div>
    </template>
    <!-- <template v-slot:share-bar-details>
      <h1 v-html="event?.name"></h1>
    </template> -->
    <template v-slot:info-area-details>
      <div class="mb-[2rem]">
        <p class="mb-[2rem]">
          Have a question you’d like answered during the event? Tell us below.
        </p>
        <textarea
          v-model="question"
          class="w-full min-h-[17rem] mb-[2rem] border border-gray-300 p-[1rem]"
          aria-label="Have a question you’d like answered during the event? Tell us below.">

        </textarea>
        <ford-button :disabled="loading" invert transparent @method="submitQuestion">
          {{ loading ? 'Submitting...' : 'Submit' }}
        </ford-button>
        <p v-if="error" class="text-red-500 pt-[2rem]">
          There was an issue submitting your question. Please try again later.
        </p>
      </div>
      <div v-html="event?.descriptionDetail" class="mb-8"></div>
      <div v-if="event.disclosureDayOfEvent">
        <disclosure-popover>
          {{ event.disclosureDayOfEvent }}
        </disclosure-popover>
      </div>
    </template>
  </generic-event>
</template>
